import AdmittedPatients from './AdmittedPatients';

export default AdmittedPatients;
